import { ITransaction, } from "../schemas/entity_set";
import { IModelService, IModelFilter, IRequestResult } from "../schemas/structure"

interface ITransactionFilter extends IModelFilter {
    memberId: number
}

interface ITransactionService extends IModelService<ITransaction> {
    recent(memberId: number): angular.IPromise<IRequestResult<Array<ITransaction>>>
    query(params: ITransactionFilter): angular.IPromise<IRequestResult<Array<ITransaction>>>
    upload(members: ITransaction[]): angular.IPromise<IRequestResult<boolean>>
    uploadInterest(members: ITransaction[]): angular.IPromise<IRequestResult<boolean>>
}

class TransactionService implements ITransactionService {

    static $inject = ["$q", "$http", "BASEAPI", "$uibModal"];

    constructor(private $q: angular.IQService,
        private $http: angular.IHttpService,
        private baseUrl: string,
        private $uibModal: angular.ui.bootstrap.IModalService) { }

    recent(memberId: number) {
        let defer = this.$q.defer()
        this.$http.get(`${this.baseUrl}/transaction/recent?memberId=${memberId}`).then((response: IRequestResult<Array<ITransaction>>) => {
            defer.resolve(response)
        })
        return defer.promise
    }

    get() {
        let defer = this.$q.defer()
        this.$http.get(`${this.baseUrl}/transaction`).then((response: IRequestResult<Array<ITransaction>>) => {
            defer.resolve(response)
        })
        return defer.promise
    }

    upload(transactions: ITransaction[]) {
        let defer = this.$q.defer();
        this.$http.post(`${this.baseUrl}/transaction/upload`, transactions).then((response: IRequestResult<boolean>) => {
            defer.resolve(response)
        })
        return defer.promise
    }

    uploadInterest(transactions: ITransaction[]) {
        let defer = this.$q.defer();
        this.$http.post(`${this.baseUrl}/transaction/interestupload`, transactions).then((response: IRequestResult<boolean>) => {
            defer.resolve(response)
        })
        return defer.promise
    }


    find(id: number) {
        let defer = this.$q.defer()
        this.$http.get(`${this.baseUrl}/transaction?id=${id}`).then((response: IRequestResult<ITransaction>) => {
            defer.resolve(response)
        })
        return defer.promise
    }

    query(params: ITransactionFilter) {
        let defer = this.$q.defer()
        this.$http.post(`${this.baseUrl}/transaction/query`, params).then((response: IRequestResult<Array<ITransaction>>) => {
            defer.resolve(response)
        })
        return defer.promise
    }

    save(transaction: ITransaction) {
        let defer = this.$q.defer()
        if (transaction.id) {
            this.$http.put(`${this.baseUrl}/transaction`, transaction).then((response: IRequestResult<ITransaction>) => {
                defer.resolve(response)
            })
        } else {
            this.$http.post(`${this.baseUrl}/transaction`, transaction).then((response: IRequestResult<ITransaction>) => {
                defer.resolve(response)
            })
        }
        return defer.promise
    }

    delete(id: number) {
        let defer = this.$q.defer()
        this.$http.delete(`${this.baseUrl}/transaction?id=${id}`).then((response: IRequestResult<ITransaction>) => {
            defer.resolve(response)
        })
        return defer.promise
    }

}

export { TransactionService, ITransactionService, ITransactionFilter }


// WEBPACK FOOTER //
// ./app/transactions/transaction_service.ts